import React from 'react';
import { Home, Settings, ScanLine, TestTube } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { clsx } from 'clsx';

interface Props {
  sampleId?: string;
}

export const BottomDock: React.FC<Props> = ({ sampleId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 pb-safe">
      <div className="mx-4 mb-3">
        <div className="flex items-center justify-around bg-white/80 backdrop-blur-2xl border border-slate-200/60 rounded-2xl py-1.5 px-2 shadow-lg shadow-slate-900/[0.04]">

          {/* Home */}
          <button
            onClick={() => navigate('/')}
            className={clsx(
              "flex flex-col items-center gap-0.5 px-5 py-1.5 rounded-xl transition-all duration-200",
              isActive('/')
                ? "text-blue-600 bg-blue-50/80"
                : "text-slate-400 active:bg-slate-50"
            )}
          >
            <Home size={20} strokeWidth={isActive('/') ? 2.5 : 1.8} />
            <span className="text-[9px] font-semibold tracking-wide">Home</span>
          </button>

          {/* Scanner — taller pill, accent color */}
          <button
            onClick={() => navigate('/scan', { state: { sampleId } })}
            className={clsx(
              "flex items-center gap-1.5 bg-blue-600 text-white px-5 py-2.5 rounded-2xl",
              "shadow-md shadow-blue-600/25 active:scale-95 transition-all duration-200"
            )}
          >
            <ScanLine size={18} strokeWidth={2.5} />
            <span className="text-xs font-bold">Scan</span>
          </button>

          {/* Rough Body */}
          <button
            onClick={() => navigate('/rough-body')}
            className={clsx(
              "flex flex-col items-center gap-0.5 px-5 py-1.5 rounded-xl transition-all duration-200",
              isActive('/rough-body')
                ? "text-blue-600 bg-blue-50/80"
                : "text-slate-400 active:bg-slate-50"
            )}
          >
            <TestTube size={20} className={clsx(isActive('/rough-body') && "fill-blue-600/20")} strokeWidth={isActive('/rough-body') ? 2.5 : 1.8} />
            <span className="text-[9px] font-semibold tracking-wide">Rough Body</span>
          </button>

        </div>
      </div>
    </div>
  );
};